/***************************************************************
5/22/2017
Alexander Self
Timesheet Container
- Displays all timesheet components; handles pre-fetching; routes, tabs
***************************************************************/
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchTimesheetData, fetchPayPeriod, fetchMyEmployees } from '../actions';
import { fetchGangs } from '../actions/team_actions';
import Tabs from '../components/tabs';
import { TIMESHEET_URLS } from '../constants';

class Timesheet extends Component {
  componentDidMount() {
    if (this.props.employees.length === 0) {
      this.props.fetchTimesheetData(this.props.user);
      this.props.fetchGangs();
    }
    if (Object.keys(this.props.payPeriod).length === 0) this.props.fetchPayPeriod();
    document.title = 'Timesheets';
    return;
  }

  render() {
    if (!this.props.employees) return <div></div>;
    return (
      <div>
        <div className="row">
          <h5>Timesheet <span className="flow-text right">{ moment().format("dddd, MMMM Do YYYY") }</span></h5><hr />
          <Tabs id={"timesheet"} tabs={TIMESHEET_URLS} level={this.props.user.level} />
        </div>
        <div>
          { this.props.children }
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    user: state.auth.user,
    employees: state.timesheet.employees,
    myEmployees: state.timesheet.myEmployees,
    payPeriod: state.misc.payPeriod
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchTimesheetData,
    fetchGangs,
    fetchPayPeriod,
    fetchMyEmployees
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Timesheet);



// WEBPACK FOOTER //
// ./src/containers/timesheet.js